<template>
  <el-table
    :data="data"
    class="tw-w-full"
    :row-class-name="() => 'tw-group'"
    :default-sort="{prop: 'action_date', order: 'descending'}"
    @sort-change="onSortChange"
  >
    <el-table-column
      prop="action_date"
      :label="$t('common.fields.date')"
      width="120"
      sortable="custom"
    >
      <template #default="{ row }">
        <div>
          {{ row.action_date.split(' ').shift() }}
        </div>
        <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark">
          {{ row.action_date.split(' ').pop() }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="action_name"
      :label="$t('adm.audit.filter.action')"
      sortable="custom"
      min-width="150"
    >
      <template #default="{ row }">
        {{ $capitalize(row.action_name) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="action_user"
      :label="$t('adm.audit.filter.by_user')"
      sortable="custom"
      min-width="150"
    >
      <template #default="{ row }">
        <template v-if="row.action_user.includes('(')">
          <div>
            {{ row.action_user.split(' (').shift() }}
          </div>
          <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark">
            {{ row.action_user.split(' (').pop().replace(')', '') }}
          </div>
        </template>
        <template v-else>
          {{ scope.row.action_user }}
        </template>
      </template>
    </el-table-column>
    <el-table-column
      prop="value_old"
      :label="$t('adm.audit.table_header.old_value')"
      width="280"
    >
      <template #default="{ row }">
        <div class="tw-h-16 group-hover:tw-h-auto tw-overflow-hidden">
          <span
            class="tw-font-mono"
            v-html="getListFromObject(row.value_old)"
          />
        </div>
        <div
          class="tw-relative tw-w-full tw-h-4 tw-bg-gradient-to-b tw-from-transparent tw-to-white dark:tw-to-dm group-hover:tw-opacity-0 tw--mt-3.5"
        />
      </template>
    </el-table-column>
    <el-table-column
      prop="value_new"
      :label="$t('adm.audit.table_header.new_value')"
      width="280"
    >
      <template #default="{ row }">
        <div class="tw-h-16 group-hover:tw-h-auto tw-overflow-hidden">
          <span
            class="tw-font-mono"
            v-html="getListFromObject(row.value_new)"
          />
        </div>
        <div
          class="tw-relative tw-w-full tw-h-4 tw-bg-gradient-to-b tw-from-transparent tw-to-white dark:tw-to-dm group-hover:tw-opacity-0 tw--mt-3.5"
        />
      </template>
    </el-table-column>
    <el-table-column
      prop="severity"
      :label="$t('adm.audit.filter.severity')"
      width="90"
    >
      <template #default="{ row }">
        <span
          :class="getSeverityClass(row.severity)"
        >
          {{ severity }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'LogsTable',
  props: {
    data: {
      type: Array,
      required: true,
    },
    onSortChange: {
      type: Function,
      required: true,
    },
  },
  methods: {
    getListFromObject(data) {
      return Object.entries(data).map(([key, value]) => `${key}: ${typeof value === 'object' ? JSON.stringify(value, null, '\n') : value}`).join('<br>');
    },
    getSeverityClass(severity) {
      if (severity === 'INFO') {
        return 'tw-text-success';
      }

      if (severity === 'WARNING') {
        return 'tw-text-warning';
      }

      if (severity === 'ERROR') {
        return 'tw-text-primary dark:tw-text-dm-primary';
      }

      return '';
    },
  },
};
</script>
